import { defineStore } from 'pinia'
import { ref } from 'vue'
import { loadPiniaSlice, persistPiniaSlice } from '../persist'

export const useBookmarksStore = defineStore('bookmarks', () => {
    const markedQuestionsCount = ref(0)
    const bookmarksList = ref([])

    const setMarkedQuestionsCountTo = (count) => {
        const parsed = parseInt(count, 10)
        if (parsed >= 0) {
            markedQuestionsCount.value = parsed
            persistToLocalStorage()
        }
    }

    const incMarkedQuestionsCount = () => {
        markedQuestionsCount.value++
        persistToLocalStorage()
    }

    const decMarkedQuestionsCount = () => {
        if (markedQuestionsCount.value > 0) {
            markedQuestionsCount.value--
            persistToLocalStorage()
        }
    }

    const persistToLocalStorage = () => {
        persistPiniaSlice('bookmarksStore', {
            markedQuestionsCount: markedQuestionsCount.value,
        })
    }

    const loadFromLocalStorage = () => {
        const stored = loadPiniaSlice('bookmarksStore')
        if (!stored) return
        if (typeof stored.markedQuestionsCount !== 'undefined') {
            markedQuestionsCount.value = stored.markedQuestionsCount
        }
    }

    loadFromLocalStorage()

    const setBookmarksList = (list) => {
        bookmarksList.value = list
        persistToLocalStorage()
    }

    return {
        markedQuestionsCount,
        bookmarksList,
        setMarkedQuestionsCountTo,
        incMarkedQuestionsCount,
        decMarkedQuestionsCount,
        setBookmarksList,
    }
})
